import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IApiResponse, IFetchCronJobsTrackerData } from "@/services/cronJobsTracker/cronJobsTracker.types";

// Define the initial state
export interface CronJobsTrackerState {
  cronJobsTrackerData: IApiResponse // Ensure default state is defined
  loading: boolean;
  error: boolean;
}

export const initialState: CronJobsTrackerState = {
  cronJobsTrackerData: { 
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: "",
  },
  loading: false,
  error: false,
  }


const cronJobsTrackerSlice = createSlice({
  name: "cronJobsTracker",
  initialState,
  reducers: {
    getCronJobsTrackerData: (state, action: PayloadAction<IFetchCronJobsTrackerData>) => {
      state.loading = true;
    },
    getCronJobsTrackerDataSuccess: (state, action: PayloadAction<IApiResponse>) => {
      state.loading = false;
      state.cronJobsTrackerData = action.payload;
      state.error = false;
    },
    getCronJobsTrackerDataFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
      state.cronJobsTrackerData = {...initialState?.cronJobsTrackerData};
    },
  },
});
const cronJobsTrackerDataReducer = cronJobsTrackerSlice.reducer;

// Export the actions
export const { getCronJobsTrackerData, getCronJobsTrackerDataSuccess, getCronJobsTrackerDataFailure } =
  cronJobsTrackerSlice.actions;

// Export the reducer
export default cronJobsTrackerDataReducer;

